export const TimeClockCircleAlternate = () => (
  <>
    <path
      d="M12,0C5.4,0,0,5.4,0,12s5.4,12,12,12s12-5.4,12-12S18.6,0,12,0z M12,22C6.5,22,2,17.5,2,12S6.5,2,12,2s10,4.5,10,10
		S17.5,22,12,22z"
    />
    <path
      d="M17.1,15.8l-4.6-4.2V6.5c0-0.6-0.4-1-1-1s-1,0.4-1,1V12c0,0.3,0.1,0.5,0.3,0.7l5,4.5c0.4,0.4,1,0.4,1.4-0.1c0,0,0,0,0,0
		C17.6,16.8,17.5,16.2,17.1,15.8C17.1,15.8,17.1,15.8,17.1,15.8z"
    />
  </>
);
